<template>
  <div class="content-container">
    <InfoList style="padding-top: 0" class="das-form-container" :columns="1">
      <InfoListLabel>
        <div class="label">Thu ngân</div>
      </InfoListLabel>
      <InfoListInput class="das-form-input">
        <div>
          {{ workShiftInfo?.username }}
        </div>
      </InfoListInput>

      <InfoListLabel>
        <div class="label">Quầy</div>
      </InfoListLabel>
      <InfoListInput class="das-form-input">
        <div>{{ workShiftInfo?.ticket_office_name }}</div>
      </InfoListInput>

      <InfoListLabel>
        <div class="label das-label">Thời gian mở ca</div>
      </InfoListLabel>
      <InfoListInput class="das-form-input">
        <div>{{ workShiftInfo?.start_time }}</div>
      </InfoListInput>
      <InfoListLabel>
        <div class="label das-label">Thời gian đóng ca</div>
      </InfoListLabel>
      <InfoListInput class="das-form-input">
        <div>{{ workShiftInfo?.end_time }}</div>
      </InfoListInput>
    </InfoList>
    <div v-loading="loading" class="mt-10">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :auto-size-cell="true"
        :rows="rows"
        class="agGrid"
        :context="context"
      />
    </div>
    <div style="margin: 10px 0">
      <button
        class="btn primary medium"
        style="float: right"
        @click="routeToInvoiceReport"
      >
        {{ 'Báo cáo thu tiền theo hóa đơn' }}
      </button>
    </div>
    <div>
      <div class="button-group">
        <div style="min-width: 200px">
          <button
            :disabled="workShiftInfo == null"
            class="btn primary medium required"
            @click="openCashListReport"
          >
            {{ 'Bảng kê tiền mặt' }}
          </button>
          <p
            style="
              font-size: 10pt;
              text-decoration: underline;
              color: rgb(53 116 86);
              cursor: pointer;
            "
            @click="downloadCashReport"
          >
            {{ cashListReport }}
          </p>
        </div>
        <div style="min-width: 200px">
          <button
            :disabled="workShiftInfo == null"
            class="btn primary medium"
            @click="openAdjustReport"
          >
            {{ 'Biên bản điều chỉnh' }}
          </button>
          <p
            style="
              font-size: 10pt;
              text-decoration: underline;
              color: rgb(53 116 86);
              cursor: pointer;
            "
            @click="downloadAdjustReport"
          >
            {{ adjustedReport }}
          </p>
        </div>
        <div style="min-width: 200px">
          <button
            :disabled="workShiftInfo == null"
            class="btn primary medium"
            @click="openRefundReport"
          >
            {{ 'Yêu cầu hoàn tiền' }}
          </button>
          <p
            style="
              font-size: 10pt;
              text-decoration: underline;
              color: rgb(53 116 86);
              cursor: pointer;
            "
            @click="downloadRefundReport"
          >
            {{ refundRequestedReport }}
          </p>
        </div>
      </div>
    </div>

    <div style="display: flex; justify-content: center; margin: 10px 0">
      <button
        :disabled="cashListReport == null"
        class="btn primary medium"
        style="align-self: center"
        @click="fnCloseShiftwork"
      >
        {{ 'Đóng ca' }}
      </button>
    </div>
    <el-dialog
      append-to-body
      title="Bảng kê tiền mặt"
      :visible.sync="cashListReportDialog"
      :close-on-click-modal="false"
      width="80%"
      @closed="cashListReportDialog = false"
    >
      <cashListReportDialog
        ref="cashListReportDialog"
        :work-shift-info="workShiftInfo"
      ></cashListReportDialog>
      <span
        slot="footer"
        class="dialog-footer"
        style="display: flex; gap: 10px; justify-content: flex-end"
      >
        <button class="btn primary small" @click="confirmCashReport">
          Cập nhật
        </button>
        <button
          class="btn primary small outline"
          @click="cashListReportDialog = false"
        >
          Đóng
        </button>
      </span>
    </el-dialog>
    <el-dialog
      append-to-body
      title="Biên bản điều chỉnh"
      :visible.sync="adjustReportDialog"
      :close-on-click-modal="false"
      width="80%"
      @closed="adjustReportDialog = false"
    >
      <adjustReportDialog
        ref="adjustReportDialog"
        :work-shift-info="workShiftInfo"
        @updateAdjustInfo="updateAdjustInfo"
        @updateAdjustReport="updateAdjustReport"
      ></adjustReportDialog>
      <span
        slot="footer"
        class="dialog-footer"
        style="display: flex; gap: 10px; justify-content: space-between"
      >
        <button class="btn primary small" @click="onAddAdjustRow">Thêm</button>

        <button class="btn primary small" @click="onAdjustedReportConfirm">
          Cập nhật
        </button>
      </span>
    </el-dialog>
    <el-dialog
      append-to-body
      title="Yêu cầu hoàn tiền"
      :visible.sync="refundReportDialog"
      :close-on-click-modal="false"
      width="80%"
      @closed="refundReportDialog = false"
    >
      <refundReportDialog
        ref="refundReportDialog"
        :work-shift-info="workShiftInfo"
        @updateRefundRequestedInfo="updateRefundRequestedInfo"
        @updateRefundRequestedReport="updateRefundRequestedReport"
      ></refundReportDialog>
      <span
        slot="footer"
        class="dialog-footer"
        style="display: flex; gap: 10px; justify-content: space-between"
      >
        <button class="btn primary small" @click="onAddRefundRow">Thêm</button>

        <button class="btn primary small" @click="onRefundReportConfirm">
          Cập nhật
        </button>
      </span>
    </el-dialog>

    <div
      v-if="cashListReport !== null"
      class="flex-col justify-center .align-center"
      style="position: absolute; top: -20000px"
    >
      <!-- ; top: -20000px -->
      <div id="cashListReportOrigin">
        <div class="flex-col justify-start items-start full-w mt-2">
          <table id="tableeee" class="w-full">
            <!-- <tbody> -->
            <tr class="rows-h">
              <td
                v-for="(item, index) in cashReportHeader"
                :key="index"
                class="cash-table !px-2 !pb-4 font-semibold"
                :class="[
                  index === 0 ? 'no-row' : '',
                  index === cashReportHeader.length - 1 ? 'note-field' : ''
                ]"
              >
                {{ item }}
              </td>
            </tr>
            <tr
              v-for="(item, index) in cashListInfo.money_denominations"
              :key="index"
              class="rows"
            >
              <td class="cash-table !px-2 !pb-4 no-row">{{ index + 1 }}</td>
              <td class="cash-table !px-2 !pb-4">
                {{
                  index <= 9
                    ? Number(item.denomination).toLocaleString('en-US')
                    : item.denomination
                }}
              </td>
              <td class="cash-table !px-2 !pb-4">
                {{
                  index <= 9
                    ? Number(item.quantity).toLocaleString('en-US')
                    : item.quantity
                }}
              </td>
              <td class="cash-table !px-2 !pb-4">
                {{
                  index <= 9
                    ? Number(item.total).toLocaleString('en-US')
                    : item.total
                }}
              </td>
              <td class="cash-table !px-2 !pb-4 note-field">{{ item.note }}</td>
            </tr>
            <tr class="rows">
              <!-- <td class="cash-table !px-2 !pb-4 no-row"></td> -->
              <td :colspan="2" class="cash-table !px-2 !pb-4 font-semibold">
                Tổng cộng
              </td>
              <td class="cash-table !px-2 !pb-4">
                {{ Number(cashListInfo.quantity).toLocaleString('en-US') }}
              </td>
              <td class="cash-table !px-2 !pb-4">
                {{ Number(cashListInfo.total).toLocaleString('en-US') }}
              </td>
              <td class="cash-table !px-2 !pb-4 note-field"></td>
            </tr>
            <!-- </tbody> -->
          </table>
        </div>
      </div>
    </div>
    <!-- cash export pdf -->
    <div
      v-if="cashListReport !== null && isDownloadCash"
      class="flex flex-col justify-center align-center max-w-5xl"
      style="position: absolute; top: -20000px"
    >
      <!-- ; top: -20000px -->
      <div id="cashListReport">
        <div class="flex flex-col justify-center align-center">
          <div class="logo">
            <img
              src="@/assets/images/mci_logo_green_rectangle.png"
              alt="logo"
              style="width: 300px"
            />
          </div>
          <span
            class="text-3xl font-bold capitalize leading-10 mb-3 mt-2"
            style="font-size: 28px; font-weight: bold"
            >BẢNG KÊ TIỀN MẶT</span
          >
          <span>{{ cashReportDate }}</span>
        </div>
        <div class="flex flex-col justify-start items-start w-full mt-2">
          <div class="section-box mb-4">
            <div class="das-form-container">
              <div class="das-form-group">
                <span>{{ datetimeDisplay }}</span>
                <InfoList
                  style="padding-top: 0"
                  class="das-form-container"
                  :columns="1"
                >
                  <InfoListLabel>
                    <div class="label">Thu ngân</div>
                  </InfoListLabel>
                  <InfoListInput class="das-form-input">
                    <div>
                      {{ workShiftInfo?.username }}
                    </div>
                  </InfoListInput>

                  <InfoListLabel>
                    <div class="label">Quầy</div>
                  </InfoListLabel>
                  <InfoListInput class="das-form-input">
                    <div>{{ workShiftInfo?.ticket_office_name }}</div>
                  </InfoListInput>

                  <InfoListLabel>
                    <div class="label das-label">Kế toán nhận</div>
                  </InfoListLabel>
                  <InfoListInput class="das-form-input">
                    <div>{{ 'Bùi Kim Thanh' }}</div>
                  </InfoListInput>
                </InfoList>
              </div>
            </div>
          </div>
          <table id="tableeee" class="w-full">
            <tbody>
              <div v-for="(itemP, indexP) in cashList" :key="indexP">
                <tr class="rows-h">
                  <td
                    v-for="(item, index) in cashReportHeader"
                    :key="index"
                    class="cash-table !px-2 !pb-4 font-semibold"
                    :class="[
                      index === 0 ? 'no-row' : '',
                      index === cashReportHeader.length - 1 ? 'note-field' : ''
                    ]"
                  >
                    {{ item }}
                  </td>
                  <!-- <td class="cash-table !px-2 !pb-4 no-row">{{ 'STT' }}</td>
            <td class="cash-table !px-2 !pb-4 no-row">{{ 'Mệnh giá VNĐ'}}</td>
            <td class="cash-table !px-2 !pb-4 no-row">{{ 'Số lượng' }}</td>
            <td class="cash-table !px-2 !pb-4 no-row">{{ 'Thành tiền'}}</td>
            <td class="cash-table !px-2 !pb-4 no-row">{{ 'Ghi chú' }}</td> -->
                </tr>
                <tr
                  v-for="(item, index) in itemP"
                  :key="index"
                  class="rows"
                  :class="[
                    index + 1 === itemP.length && indexP + 1 !== cashList.length
                      ? 'break-page'
                      : '',
                    index + 1 === itemP.length && indexP + 1 === cashList.length
                      ? 'bottom-border'
                      : ''
                  ]"
                >
                  <td
                    v-if="item.no !== 14"
                    class="cash-table !px-2 !pb-4 no-row"
                  >
                    {{ item.no }}
                  </td>
                  <td
                    :colspan="item.no === 14 ? 2 : null"
                    class="cash-table !px-2 !pb-4"
                    :class="item.no === 14 ? 'font-semibold' : ''"
                  >
                    {{
                      item.no <= 10
                        ? Number(item.denomination).toLocaleString('en-US')
                        : item.denomination
                    }}
                  </td>
                  <td class="cash-table !px-2 !pb-4">
                    {{
                      item.no <= 10
                        ? Number(item.quantity).toLocaleString('en-US')
                        : item.quantity
                    }}
                  </td>
                  <td class="cash-table !px-2 !pb-4">
                    {{
                      item.no <= 10 || item.no == 14
                        ? Number(item.total).toLocaleString('en-US')
                        : item.total
                    }}
                  </td>
                  <td class="cash-table !px-2 !pb-4 note-field">
                    {{ item.note }}
                  </td>
                </tr>
                <br />
              </div>
              <!-- <tr class="rows">
              <td :colspan="2" class="cash-table !px-2 !pb-4 font-semibold">Tổng cộng</td>
              <td class="cash-table !px-2 !pb-4">
                {{ Number(cashListInfo.quantity).toLocaleString('en-US') }}
              </td>
              <td class="cash-table !px-2 !pb-4">
                {{ Number(cashListInfo.total).toLocaleString('en-US') }}
              </td>
              <td class="cash-table !px-2 !pb-4 note-field"></td>
            </tr> -->
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div
      v-if="adjustedReport !== null"
      class="flex flex-col justify-center items-center"
      style="position: absolute; top: -20000px"
    >
      <!-- ; top: -20000px -->
      <div id="adjustedReportOrigin">
        <div class="flex flex-col justify-start items-start w-full mt-2">
          <table id="tableeee" class="mt-2 w-full">
            <tbody>
              <tr class="rows-h p-2">
                <td
                  class="cash-table !px-2 !pb-4 font-semibold no-row"
                  :rowspan="2"
                >
                  {{ 'STT' }}
                </td>
                <td
                  class="cash-table !px-2 !pb-4 font-semibold invoice-row"
                  :rowspan="2"
                >
                  {{ 'Recode' }}
                </td>
                <td class="cash-table !px-2 !pb-4 font-semibold" :colspan="2">
                  {{ 'Thông tin cần điều chỉnh' }}
                </td>
                <td class="cash-table !px-2 !pb-4 font-semibold" :colspan="2">
                  {{ 'Tên tài khoản' }}
                </td>
              </tr>
              <tr class="rows-h p-2">
                <td class="cash-table !px-2 !pb-4 font-semibold">
                  {{ 'Trước điều chỉnh' }}
                </td>
                <td class="cash-table !px-2 !pb-4 font-semibold">
                  {{ 'Sau điều chỉnh' }}
                </td>
                <td class="cash-table !px-2 !pb-4 font-semibold">
                  {{ 'Trước điều chỉnh' }}
                </td>
                <td class="cash-table !px-2 !pb-4 font-semibold">
                  {{ 'Sau điều chỉnh' }}
                </td>
              </tr>
              <tr
                v-for="(item, index) in adjustInfo.adjusted_record_units"
                :key="index"
                class="rows"
              >
                <td class="cash-table !px-2 !pb-4 no-row">{{ index + 1 }}</td>
                <td class="cash-table !px-2 !pb-4 invoice-row">
                  {{ item?.invoice_code }}
                </td>
                <td class="cash-table !px-2 !pb-4">
                  {{ item?.payment_before }}
                </td>
                <td class="cash-table !px-2 !pb-4">
                  {{ item?.payment_after }}
                </td>
                <td class="cash-table !px-2 !pb-4">
                  {{ item?.infor_before }}
                </td>
                <td class="cash-table !px-2 !pb-4">
                  {{ item?.infor_after }}
                </td>
              </tr>
              <br />
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- adjust pdf export -->
    <!--  && isDownloadAdjust -->
    <div
      v-if="adjustedReport !== null && isDownloadAdjust"
      class="flex flex-col justify-center items-center"
      style="position: absolute; top: -20000px"
    >
      <!-- ; top: -20000px -->
      <div id="adjustedReport">
        <div class="flex flex-col justify-center items-center">
          <div class="logo">
            <img
              src="@/assets/images/mci_logo_green_rectangle.png"
              alt="logo"
              style="width: 300px"
            />
          </div>
          <span
            class="text-3xl font-bold capitalize leading-10 mb-3 mt-2"
            style="font-size: 28px; font-weight: bold"
            >BIÊN BẢN ĐIỀU CHỈNH</span
          >
          <span>{{ adjustReportDate }}</span>
        </div>
        <div class="flex flex-col justify-start items-start full-w mt-2">
          <div class="section-box mb-2">
            <div class="das-form-container">
              <div class="das-form-group">
                <span>{{ datetimeDisplay }}</span>
                <InfoList
                  style="padding-top: 0"
                  class="das-form-container"
                  :columns="1"
                >
                  <InfoListLabel>
                    <div class="label">Thu ngân</div>
                  </InfoListLabel>
                  <InfoListInput class="das-form-input">
                    <div>
                      {{ workShiftInfo?.username }}
                    </div>
                  </InfoListInput>

                  <InfoListLabel>
                    <div class="label">Quầy</div>
                  </InfoListLabel>
                  <InfoListInput class="das-form-input">
                    <div>{{ workShiftInfo?.ticket_office_name }}</div>
                  </InfoListInput>
                </InfoList>
              </div>
            </div>
          </div>
          <table id="tableeee" class="mt-2 full-w">
            <tbody>
              <div v-for="(itemP, indexP) in adjustRecordUnit" :key="indexP">
                <tr class="rows-h p-2">
                  <!-- <td
                class="cash-table !px-2 !pb-4  border font-semibold"
                v-for="(item, index) in refundReportHeader"
                :key="index"
              >
                {{ item }}
              </td> -->
                  <td
                    class="cash-table !px-2 !pb-4 font-semibold no-row"
                    :rowspan="2"
                  >
                    {{ 'STT' }}
                  </td>
                  <td
                    class="cash-table !px-2 !pb-4 font-semibold invoice-row"
                    :rowspan="2"
                  >
                    {{ 'Recode' }}
                  </td>
                  <td class="cash-table !px-2 !pb-4 font-semibold" :colspan="2">
                    {{ 'Thông tin cần điều chỉnh' }}
                  </td>
                  <td class="cash-table !px-2 !pb-4 font-semibold" :colspan="2">
                    {{ 'Tên tài khoản' }}
                  </td>
                </tr>
                <tr class="rows-h p-2">
                  <td class="cash-table !px-2 !pb-4 font-semibold">
                    {{ 'Trước điều chỉnh' }}
                  </td>
                  <td class="cash-table !px-2 !pb-4 font-semibold">
                    {{ 'Sau điều chỉnh' }}
                  </td>
                  <td class="cash-table !px-2 !pb-4 font-semibold">
                    {{ 'Trước điều chỉnh' }}
                  </td>
                  <td class="cash-table !px-2 !pb-4 font-semibold">
                    {{ 'Sau điều chỉnh' }}
                  </td>
                </tr>
                <tr
                  v-for="(item, index) in itemP"
                  :key="index"
                  class="rows"
                  :class="[
                    index + 1 === itemP.length &&
                    indexP + 1 !== adjustRecordUnit.length
                      ? 'break-page'
                      : '',
                    index + 1 === itemP.length &&
                    indexP + 1 === adjustRecordUnit.length
                      ? 'bottom-border'
                      : ''
                  ]"
                >
                  <td class="cash-table !px-2 !pb-4 no-row">
                    {{ item.no }}
                  </td>
                  <td class="cash-table !px-2 !pb-4 invoice-row">
                    {{ item.invoice_code }}
                  </td>
                  <td class="cash-table !px-2 !pb-4">
                    {{ item.payment_before }}
                  </td>
                  <td class="cash-table !px-2 !pb-4">
                    {{ item.payment_after }}
                  </td>
                  <td class="cash-table !px-2 !pb-4">
                    {{ item.infor_before }}
                  </td>
                  <td class="cash-table !px-2 !pb-4">
                    {{ item.infor_after }}
                  </td>
                </tr>
                <br />
                <!-- <br class="break-page" /> -->
              </div>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div
      v-if="refundRequestedReport !== null"
      class="flex flex-col justify-center items-center"
      style="position: absolute; top: -30000px"
    >
      <!-- ; top: -20000px -->
      <div id="refundRequestedReportOrigin">
        <div class="flex flex-col justify-start items-start full-w mt-2">
          <table id="tableeee" class="mt-2 full-w">
            <tbody>
              <tr class="rows-h p-2">
                <td
                  v-for="(item, index) in refundReportHeader"
                  :key="index"
                  class="cash-table !px-2 !pb-4 font-semibold"
                  :class="[
                    index === 0 ? 'no-row' : '',
                    index + 1 === 2 ? 'invoice-row' : '',
                    index + 1 === 3 || index + 1 === 6 ? 'number-row' : ''
                  ]"
                >
                  {{ item }}
                </td>
              </tr>
              <tr
                v-for="(
                  item, index
                ) in refundRequestedInfo.refund_request_units"
                :key="index"
                class="rows"
              >
                <td class="cash-table !px-2 !pb-4 no-row">{{ index + 1 }}</td>
                <td class="cash-table !px-2 !pb-4 invoice-row">
                  {{ item.invoice_code }}
                </td>
                <td class="cash-table !px-2 !pb-4 number-row">
                  {{ Number(item.money).toLocaleString('en-US') }}
                </td>
                <td class="cash-table !px-2 !pb-4">
                  {{ item.bank_account_name }}
                </td>
                <td class="cash-table !px-2 !pb-4">
                  {{ item.bank_name }}
                </td>
                <td class="cash-table !px-2 !pb-4 number-row">
                  {{ item.bank_account_number }}
                </td>
                <td class="cash-table !px-2 !pb-4">{{ item.note }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- refund export pdf -->
    <div
      v-if="refundRequestedReport !== null && isDownloadRefund"
      class="flex flex-col justify-center align-center"
      style="position: absolute; top: -30000px"
    >
      <!-- ; top: -20000px -->
      <div id="refundRequestedReport">
        <div class="flex flex-col justify-center align-center">
          <div class="logo">
            <img
              src="@/assets/images/mci_logo_green_rectangle.png"
              alt="logo"
              style="width: 300px"
            />
          </div>
          <span
            class="text-3xl font-bold capitalize leading-10 mb-3 mt-2"
            style="font-size: 28px; font-weight: bold"
            >YÊU CẦU HOÀN TIỀN</span
          >
          <span>{{ refundReportDate }}</span>
        </div>
        <div class="flex flex-col justify-start items-start w-full mt-2">
          <div class="section-box mb-2">
            <div class="das-form-container">
              <div class="das-form-group">
                <span>{{ datetimeDisplay }}</span>
                <InfoList
                  style="padding-top: 0"
                  class="das-form-container"
                  :columns="1"
                >
                  <InfoListLabel>
                    <div class="label">Thu ngân</div>
                  </InfoListLabel>
                  <InfoListInput class="das-form-input">
                    <div>
                      {{ workShiftInfo?.username }}
                    </div>
                  </InfoListInput>

                  <InfoListLabel>
                    <div class="label">Quầy</div>
                  </InfoListLabel>
                  <InfoListInput class="das-form-input">
                    <div>{{ workShiftInfo?.ticket_office_name }}</div>
                  </InfoListInput>

                  <InfoListLabel>
                    <div class="label">Người xác nhận</div>
                  </InfoListLabel>
                  <InfoListInput class="das-form-input">
                    <div>{{ 'Kế toán trưởng' }}</div>
                  </InfoListInput>
                </InfoList>
              </div>
            </div>
          </div>
          <table id="tableeee" class="mt-2 w-full">
            <tbody>
              <div v-for="(itemP, indexP) in refundRecordUnit" :key="indexP">
                <tr class="rows-h p-2">
                  <td
                    v-for="(item, index) in refundReportHeader"
                    :key="index"
                    class="cash-table !px-2 !pb-4 font-semibold"
                    :class="[
                      index === 0 ? 'no-row' : '',
                      index + 1 === 2 ? 'invoice-row' : '',
                      index + 1 === 3 || index + 1 === 6 ? 'number-row' : ''
                    ]"
                  >
                    {{ item }}
                  </td>
                </tr>
                <tr
                  v-for="(item, index) in itemP"
                  :key="index"
                  class="rows"
                  :class="[
                    index + 1 === itemP.length &&
                    indexP + 1 !== refundRecordUnit.length
                      ? 'break-page'
                      : '',
                    index + 1 === itemP.length &&
                    indexP + 1 === refundRecordUnit.length
                      ? 'bottom-border'
                      : ''
                  ]"
                >
                  <td class="cash-table !px-2 !pb-4 no-row">{{ item.no }}</td>
                  <td class="cash-table !px-2 !pb-4 invoice-row">
                    {{ item.invoice_code }}
                  </td>
                  <td class="cash-table !px-2 !pb-4 number-row">
                    {{ Number(item.money).toLocaleString('en-US') }}
                  </td>
                  <td class="cash-table !px-2 !pb-4">
                    {{ item.bank_account_name }}
                  </td>
                  <td class="cash-table !px-2 !pb-4">
                    {{ item.bank_name }}
                  </td>
                  <td class="cash-table !px-2 !pb-4 number-row">
                    {{ item.bank_account_number }}
                  </td>
                  <td class="cash-table !px-2 !pb-4">{{ item.note }}</td>
                </tr>
                <br />
              </div>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import Breadcrumb from '@/components/Breadcrumb'
import RightPanel from '@/components/RightPanel'
import SelectWithSearchTable from '@/components/inputs/SelectWithSearchTable.vue'
import { component as VueNumber } from '@coders-tm/vue-number-format'
import {
  CellRenderNumberInputBySum,
  CellRenderTextInput
} from '@/utils/cellRenders'
import { getAllHotel } from '@/api/hotel'
import CalendarSelect from '@/components/CalendarSelect/CalendarSelect.vue'
import {
  getHistoryBreakfast,
  setHistoryBreakfast
} from '@/api/business_area_service/breakfastReal'
import {
  getWorkShiftInfoApi,
  uploadCashReport,
  closeShiftwork
} from '@/api/cashier_service/closeShiftWork.js'
import cashListReportDialog from './components/cashListReportDialog'
import adjustReportDialog from './components/adjustReportDialog'
import refundReportDialog from './components/refundReportDialog.vue'
import { removeToken } from '@/utils/auth.js'
import { logoutApi } from '@/api/auth_service/login'
import Vue from 'vue'
import html2pdf from 'html2pdf.js'

export default {
  components: {
    Breadcrumb,
    RightPanel,
    SelectWithSearchTable,
    VueNumber,
    CellRenderNumberInputBySum,
    CalendarSelect,
    CellRenderTextInput,
    // CellRenderNoteInput,
    cashListReportDialog,
    adjustReportDialog,
    refundReportDialog
  },
  data() {
    return {
      cashListReportDialog: false,
      adjustReportDialog: false,
      refundReportDialog: false,
      loading: false,
      listAssign: [],

      workShiftInfo: null,

      context: null,
      columns: [
        {
          headerName: this.$t('grid.column.cash'),
          field: 'cash',
          flex: 1,
          valueGetter: params => {
            return this.$displayCurrency(params.data.cash)
          },
          sortable: false
        },
        {
          headerName: 'Hoàn',
          field: 'refund',
          sortable: false,
          valueGetter: params => {
            return this.$displayCurrency(params.data.refund)
          },
          flex: 1,
          wrapText: true,
          autoHeight: true
        }
      ],
      rows: [],

      cashReportHeader: [
        'STT',
        'Mệnh giá VNĐ',
        'Số lượng',
        'Thành tiền',
        'Ghi chú'
      ],
      refundReportHeader: [
        'STT',
        'Số hóa đơn',
        'Số tiền VNĐ',
        'Tên tài khoản',
        'Ngân hàng',
        'Số tài khoản',
        'Ghi chú'
      ],

      //file name dâta
      cashReportId: null,
      cashListReport: null,
      cashListInfo: null,
      isDownloadCash: false,

      adjustInfo: null,
      adjustedReport: null,
      isDownloadAdjust: null,

      refundRequestedReport: null,
      refundRequestedInfo: null,
      isDownloadRefund: null
    }
  },
  computed: {
    cashList() {
      var result = []
      var tempPart = []
      var tempHeight = 0
      var index = 0
      const rowElement = document.querySelectorAll(
        '#cashListReportOrigin #tableeee .rows'
      )
      console.log('hhaa', rowElement)
      var list = [
        ...this.cashListInfo.money_denominations,
        {
          denomination: 'Tổng cộng',
          quantity: this.cashListInfo.quantity,
          total: this.cashListInfo.total
        }
      ]
      if (rowElement.length > 0) {
        for (let i = 0; i < list.length; i++) {
          let cashRowHeight = rowElement[i].offsetHeight
          tempHeight = tempHeight + cashRowHeight
          console.log(745 - tempHeight)
          if (745 - tempHeight < cashRowHeight) {
            result.push(tempPart)
            tempPart = []
            tempHeight = 0
            break
          }
          tempPart.push({ ...list[i], no: i + 1 })
          if (i + 1 === list.length) {
            result.push(tempPart)
            return result
          }
          index = index + 1
        }
        for (let i = index; i < list.length; i++) {
          let cashRowHeight = rowElement[i].offsetHeight
          tempHeight = tempHeight + cashRowHeight
          tempPart.push({ ...list[i], no: i + 1 })
          console.log(1060 - tempHeight)
          if (1060 - tempHeight < cashRowHeight) {
            result.push(tempPart)
            tempPart = []
            tempHeight = 0
            index = i
          }
          if (i + 1 === list.length) {
            result.push(tempPart)
            break
          }
        }
        return result
      }
      return []
    },
    adjustRecordUnit() {
      var result = []
      var tempPart = []
      var index = 0
      var tempHeight = 0
      const rowElement = document.querySelectorAll(
        '#adjustedReportOrigin #tableeee .rows'
      )

      if (rowElement.length > 0) {
        for (let i = 0; i < this.adjustInfo.adjusted_record_units.length; i++) {
          let adjustedRowHeight = rowElement[i].offsetHeight
          tempHeight = tempHeight + adjustedRowHeight
          console.log(400 - tempHeight)
          if (400 - tempHeight < adjustedRowHeight) {
            result.push(tempPart)
            tempPart = []
            tempHeight = 0
            break
          }
          tempPart.push({
            ...this.adjustInfo.adjusted_record_units[i],
            no: i + 1
          })
          if (i + 1 === this.adjustInfo.adjusted_record_units.length) {
            result.push(tempPart)
            return result
          }
          index = index + 1
        }
        for (
          let i = index;
          i < this.adjustInfo.adjusted_record_units.length;
          i++
        ) {
          let adjustedRowHeight = rowElement[i].offsetHeight
          tempHeight = tempHeight + adjustedRowHeight
          console.log(650 - tempHeight)
          if (650 - tempHeight < adjustedRowHeight) {
            result.push(tempPart)
            tempPart = []
            tempHeight = 0
            index = i
          }
          tempPart.push({
            ...this.adjustInfo.adjusted_record_units[i],
            no: i + 1
          })
          if (i + 1 === this.adjustInfo.adjusted_record_units.length) {
            result.push(tempPart)
            break
          }
        }
        return result
      }
      return []
    },
    refundRecordUnit() {
      var result = []
      var tempPart = []
      var index = 0
      var tempHeight = 0
      const rowElement = document.querySelectorAll(
        '#refundRequestedReportOrigin #tableeee .rows'
      )
      if (rowElement.length > 0) {
        for (
          let i = 0;
          i < this.refundRequestedInfo.refund_request_units.length;
          i++
        ) {
          let refundRowHeight = rowElement[i].offsetHeight
          tempHeight = tempHeight + refundRowHeight
          console.log(400 - tempHeight)
          if (400 - tempHeight < refundRowHeight) {
            result.push(tempPart)
            tempPart = []
            tempHeight = 0
            break
          }
          tempPart.push({
            ...this.refundRequestedInfo.refund_request_units[i],
            no: i + 1
          })
          if (i + 1 === this.refundRequestedInfo.refund_request_units.length) {
            result.push(tempPart)
            return result
          }
          index = index + 1
        }
        for (
          let i = index;
          i < this.refundRequestedInfo.refund_request_units.length;
          i++
        ) {
          let refundRowHeight = rowElement[i].offsetHeight
          tempHeight = tempHeight + refundRowHeight
          console.log(700 - tempHeight)
          if (700 - tempHeight < refundRowHeight) {
            result.push(tempPart)
            tempPart = []
            tempHeight = 0
            index = i
          }
          tempPart.push({
            ...this.refundRequestedInfo.refund_request_units[i],
            no: i + 1
          })
          if (i + 1 === this.refundRequestedInfo.refund_request_units.length) {
            result.push(tempPart)
            break
          }
        }
        return result
      }
      return []
    },
    cashReportCreateTime() {
      return this.cashListInfo
        ? this.$moment(this.cashListInfo.create_time, 'YYYY-MM-DD HH:mm:ss')
        : ''
    },
    cashReportDate() {
      return `${String(this.cashReportCreateTime.hour()).padStart(
        2,
        '0'
      )}:${String(this.cashReportCreateTime.minute()).padStart(
        2,
        '0'
      )}, ngày ${this.cashReportCreateTime.date()} tháng ${
        this.cashReportCreateTime.month() + 1
      } năm ${this.cashReportCreateTime.year()}`
    },
    adjustReportCreateTime() {
      return this.adjustInfo ? this.$moment(this.adjustInfo.create_time) : ''
    },
    adjustReportDate() {
      return `${String(this.adjustReportCreateTime.hour()).padStart(
        2,
        '0'
      )}:${String(this.adjustReportCreateTime.minute()).padStart(
        2,
        '0'
      )}, ngày ${this.adjustReportCreateTime.date()} tháng ${
        this.adjustReportCreateTime.month() + 1
      } năm ${this.adjustReportCreateTime.year()}`
    },
    refundReportCreateTime() {
      return this.refundRequestedInfo
        ? this.$moment(this.refundRequestedInfo.create_time)
        : ''
    },
    refundReportDate() {
      return `${String(this.refundReportCreateTime.hour()).padStart(
        2,
        '0'
      )}:${String(this.refundReportCreateTime.minute()).padStart(
        2,
        '0'
      )}, ngày ${this.refundReportCreateTime.date()} tháng ${
        this.refundReportCreateTime.month() + 1
      } năm ${this.refundReportCreateTime.year()}`
    }
  },
  beforeMount() {
    this.context = {
      componentParent: this
    }
  },
  mounted() {
    this.getInfoShiftWork()
  },
  methods: {
    openCashListReport() {
      this.cashListReportDialog = true
      setTimeout(() => {
        this.$refs.cashListReportDialog.updateCurrentDatetime()
      }, 500)
    },
    openAdjustReport() {
      this.adjustReportDialog = true
      setTimeout(() => {
        this.$refs.adjustReportDialog.updateCurrentDatetime()
      }, 500)
    },
    openRefundReport() {
      this.refundReportDialog = true
      setTimeout(() => {
        this.$refs.refundReportDialog.updateCurrentDatetime()
      }, 500)
    },
    updateAdjustInfo(data) {
      this.adjustInfo = data
    },
    updateAdjustReport(data) {
      this.adjustedReport = data
    },
    updateRefundRequestedInfo(data) {
      this.refundRequestedInfo = data
    },
    updateRefundRequestedReport(data) {
      this.refundRequestedReport = data
    },
    routeToInvoiceReport() {
      console.log('redirect..')
      const routeData = this.$router.resolve({
        path: '/report/cashier_report/take_money_by_invoice_report'
      })
      window.open(routeData.href, '_blank')
    },
    onResetSearchParams() {
      this.searchParams.date = this.$moment(new Date()).format('YYYY-MM-DD')
      this.getInfoShiftWork()
    },
    async getInfoShiftWork() {
      this.loading = true
      try {
        let data = await getWorkShiftInfoApi()
        this.workShiftInfo = data.data
        this.rows = [
          {
            cash: data?.data?.cash,
            refund: data?.data?.refund
          }
        ]
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    onAddAdjustRow() {
      this.$refs.adjustReportDialog.onAddRow()
    },
    onAddRefundRow() {
      this.$refs.refundReportDialog.onAddRow()
    },
    numberInputBySumChange(params, value, sum, colName, flagSave) {
      const idx = params.rowIndex
      const gridApi = this.$refs.agGrid.gridApi
      if (flagSave) {
        this.flagCanSave = true
      } else {
        this.flagCanSave = false
      }
      this.rows[idx][colName] = `${value}/${sum}`
    },
    textInputChange(params, value, colName) {
      const idx = params.rowIndex
      if (colName === 'desc') {
        if (value?.length && value.length > 50) {
          value = value.slice(0, 50)
          this.$message({
            type: 'error',
            message: 'Số phòng vượt quá số phòng có sẵn'
          })
        }
        this.rows[idx][colName] = value
      }
    },
    async confirmCashReport() {
      // console.log('haha')
      console.log(
        'call api to confirm and close cash list report dialog',
        this.$refs.cashListReportDialog.rows
      )
      if (
        this.$refs.cashListReportDialog.rows.some(item => item.note.length > 50)
      ) {
        this.$message({
          type: 'error',
          message: t(`errorMsg.checkAgain`)
        })
        return
      }
      const cashList = this.$refs.cashListReportDialog.rows.map(item => {
        return {
          type: item.type,
          note: item.note,
          total: item.total.toString(),
          quantity: item.quantity !== null ? item.quantity.toString() : '0',
          denomination: item.denomination
        }
      })
      const pinnedRows = this.$refs.cashListReportDialog.pinnedBottomRow
      const createTime = this.$refs.cashListReportDialog.datetime.format(
        'YYYY-MM-DD HH:mm:ss'
      )
      // console.log('bienle', cashList)
      const payload = {
        ...pinnedRows[0],
        ticket_close_shift_id: this.workShiftInfo.id,
        money_denominations: cashList,
        create_time: createTime
      }
      await uploadCashReport(payload)
        .then(res => {
          console.log(res.data)
          this.cashListReport = res.data.name + '.pdf'
          this.cashReportId = res.data.id
          this.cashListInfo = res.data
          this.$message({
            type: 'success',
            message: 'Cập nhật thành công'
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: 'Cập nhật thất bại'
          })
        })
        .finally(() => {
          this.cashListReportDialog = false
          // this.loading = false
        })
    },
    downloadCashReport() {
      this.loading = true
      this.isDownloadCash = true
      setTimeout(() => {
        const svgElement = document.getElementById('cashListReport')
        console.log(svgElement)
        const options = {
          pagebreak: {
            avoid: ['.rows', '.rows-h', '.cash-table'],
            after: ['.break-page']
          },
          margin: [0.3, 0.5],
          pagesplit: true,
          filename: this.cashListReport,
          image: { type: 'jpeg', quality: 1.0 },
          html2canvas: { scale: 5.0 },
          jsPDF: {
            unit: 'in',
            orientation: 'portrait',
            format: 'a4'
          }
        }
        html2pdf().from(svgElement).set(options).save()
        // this.isDownloadCash = false
        this.loading = false
      }, 2000)
    },
    async onAdjustedReportConfirm() {
      console.log('call api to confirm and close adjusted report dialog')
      const isValid = await this.$refs.adjustReportDialog.onConfirm()
      if (isValid) this.adjustReportDialog = false
    },
    async onRefundReportConfirm() {
      console.log('call api to confirm and close adjusted report dialog')
      const isValid = await this.$refs.refundReportDialog.onConfirm()
      if (isValid) this.refundReportDialog = false
    },
    downloadAdjustReport() {
      this.loading = true
      this.isDownloadAdjust = true
      setTimeout(() => {
        const svgElement = document.getElementById('adjustedReport')
        console.log(svgElement)
        const options = {
          pagebreak: {
            avoid: ['.rows', '.rows-h', '.cash-table'],
            after: ['.break-page']
            // mode: ['avoid-all', 'css', 'legacy']
          },
          margin: [0.3, 0.5],
          pagesplit: true,
          filename: this.adjustedReport,
          image: { type: 'jpeg', quality: 1.0 },
          html2canvas: { scale: 5.0 },
          jsPDF: {
            unit: 'in',
            orientation: 'landscape',
            format: 'a4'
          }
        }
        html2pdf().from(svgElement).set(options).save()
        this.isDownloadAdjust = false
        this.loading = false
      }, 2000)
    },
    downloadRefundReport() {
      this.loading = true
      this.isDownloadRefund = true
      setTimeout(() => {
        const svgElement = document.getElementById('refundRequestedReport')
        console.log(svgElement)
        const options = {
          pagebreak: {
            avoid: ['.rows', '.rows-h', '.cash-table'],
            after: ['.break-page']
          },
          margin: [0.3, 0.5],
          pagesplit: true,
          filename: this.refundRequestedReport,
          image: { type: 'jpeg', quality: 1.0 },
          html2canvas: { scale: 5.0 },
          jsPDF: {
            unit: 'in',
            orientation: 'landscape',
            format: 'a4'
          }
        }
        html2pdf().from(svgElement).set(options).save()
        this.isDownloadRefund = false
        this.loading = false
      }, 2000)
    },
    async fnCloseShiftwork() {
      console.log('call api to close shiftwork and logout')
      // router.push('/close-sales-shiftwork/adjust_list')
      this.loading = true
      const payload = {
        ...this.workShiftInfo,
        cash_report_id: this.cashReportId,
        ticket_site: false
      }
      await closeShiftwork(payload)
        .then(res => {
          console.log(res)
          // ElMessage({
          //   type: 'success',
          //   message: t('message.success.confirmSuccessfully')
          // })
          this.$message({
            type: 'success',
            message: 'Đóng ca thành công'
          })
          this.onLogOut()
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          // ElMessage({
          //   type: 'error',
          //   message: t(`message.error.${message}`)
          // })
          this.$message({
            type: 'error',
            message: 'Đóng ca thất bại'
          })
        })
        .finally(() => {
          this.loading = false
        })
    },
    async onLogOut() {
      console.log('hahah')
      await logoutApi()
        .then(() => {
          removeToken()
          localStorage.removeItem('listPath')
          localStorage.removeItem('authorizedList')
          localStorage.removeItem('UserInfo')
          this.$router.push('/login')
        })
        .catch(() => {
          this.$message({
            message: 'Có lỗi xảy ra khi đăng xuất, thử lại sau',
            type: 'error'
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.button-containers {
  position: fixed;
  bottom: 30px;
  right: 20px;
}
.button-group {
  display: flex;
  justify-content: center;
  gap: 20px;
}
td {
  padding: 5px;
  text-align: center;
}
.required:after {
  content: ' *';
  color: red;
}

table#tableeee {
  border-collapse: collapse;
  border-spacing: 0;

  tr {
    &:last-child {
      td,
      th {
        border-bottom: 1px solid black;
      }
    }

    th {
      background-color: lightgrey;
    }

    td,
    th {
      border-top: 1px solid black;
      border-left: 1px solid black !important;

      &:last-child {
        border-right: 1px solid black;
      }
    }
  }
  .break-page {
    border-bottom: 1px solid black;
  }

  .bottom-border {
    border-bottom: 1px solid black;
  }
}
#cashListReport td.cash-table,
#cashListReportOrigin td.cash-table {
  max-width: 150px;
  width: 150px;
  word-wrap: break-word;
  padding: 12px 8px !important ;
}
#refundRequestedReport td.cash-table,
#refundRequestedReportOrigin td.cash-table {
  max-width: 190px;
  width: 190px;
  word-wrap: break-word;
  padding: 12px 8px !important ;
}
#adjustedReport td.cash-table,
#adjustedReportOrigin td.cash-table {
  max-width: 212px;
  width: 212px;
  word-wrap: break-word;
  padding: 12px 8px !important ;
}
.invoice-row {
  max-width: 125px !important;
  width: 125px !important;
}
.number-row {
  max-width: 140px !important;
  width: 140px !important;
}
.note-field {
  max-width: 190px !important;
  width: 190px !important;
}
.no-row {
  max-width: 50px !important;
  width: 50px !important;
}

.agGrid {
  height: 100px !important;
}
</style>
